/**
 * Opportunity framing for finding severity.
 *
 * The stored severity enum (critical/high/medium/low) is preserved end-to-end
 * for finding identity and history — these helpers only change how it is
 * PRESENTED. Instead of an audit-style "critical / high" in alarm-red, severity
 * reads as an opportunity to elevate, rendered on a calm single-hue blue ladder
 * (Big win = strongest → Fine-tune = faintest). Functional error states keep
 * their own red badge classes and do not flow through here.
 */

/** Map a stored severity enum to its Opportunity display label. */
export function opportunityLabel(severity?: string): string {
  const map: Record<string, string> = {
    critical: 'Big win',
    high: 'Strong lift',
    medium: 'Nice-to-have',
    low: 'Fine-tune',
  };
  return severity ? (map[severity] ?? severity) : 'Fine-tune';
}

/** Map a stored severity enum to its blue-ladder badge class. */
export function opportunityBadgeClass(severity?: string): string {
  const map: Record<string, string> = {
    critical: 'badge-opp-1',
    high: 'badge-opp-2',
    medium: 'badge-opp-3',
    low: 'badge-opp-4',
  };
  return severity ? (map[severity] ?? 'badge-opp-4') : 'badge-opp-4';
}
